// extracted by mini-css-extract-plugin
export default {"dialogContent":"ProviderDisclosures_dialogContent__X-hsA"};